import { CheckCircle } from "@livechat/design-system-icons";

import { TicketStatus, TicketStatusFormattedValues } from "interfaces/entities/ticket";

import { IFilterConfig, IFilterLabelValue } from "../interfaces";

export const ticketStatusFilterConfig: IFilterConfig = {
  title: "Status",
  icon: CheckCircle,
  multiple: true,
  getFilterLabelValues: (filterValues: TicketStatus[] | null): IFilterLabelValue[] => {
    if (filterValues === null) {
      return [];
    }

    return filterValues.map((filterValue: keyof typeof TicketStatusFormattedValues) => ({
      key: filterValue,
      label: TicketStatusFormattedValues[filterValue],
    }));
  },
};
